import { SearchQuery as ApiSearchQuery } from '@/contract/search-query.contract';

export class SearchQuery {
  page = 1;
  pageSize = 10;
  rootCategory?: string;
  category?: string;
  freeTextSearchTerm?: string;
  filters: { [key: string]: string[] } = {};

  public withPage(pageNumber: number): this {
    this.page = pageNumber;
    return this;
  }

  public withPageSize(pageSize: number): this {
    this.pageSize = pageSize;
    return this;
  }

  public withCategory(rootCategory: string, category: string): this {
    if (!rootCategory || !category) {
      return this;
    }
    this.freeTextSearchTerm = undefined;
    this.rootCategory = rootCategory;
    this.category = category;
    return this;
  }

  public withFreeTextSearchTerm(term: string): this {
    if (!term) {
      return this;
    }
    this.rootCategory = undefined;
    this.category = undefined;
    this.freeTextSearchTerm = term;
    return this;
  }

  public withFilters(filters: { [key: string]: string[] }): this {
    this.filters = filters;
    return this;
  }

  public toApi(): ApiSearchQuery {
    return {
      filters: this.filters,
      page: this.page - 1, // api uses 0-based index pages
      size: this.pageSize,
      category: this.rootCategory,
      subcategory: this.category,
      query: this.freeTextSearchTerm,
    };
  }

  public toString(): string {
    return JSON.stringify(this.toApi());
  }
}
